import {Map, fromJS, List} from "immutable";

import {
    GET_STOCK_LIST_SUCCESS,
    GET_STOCK_LIST_REQUEST,
    GET_STOCK_LIST_ERROR,
    GET_STOCK_REQUEST,
    GET_STOCK_SUCCESS,
    GET_STOCK_ERROR,
    CREATE_STOCK_REQUEST,
    CREATE_STOCK_SUCCESS,
    CREATE_STOCK_ERROR,
    UPDATE_STOCK_REQUEST,
    UPDATE_STOCK_SUCCESS,
    UPDATE_STOCK_ERROR,
    CLEAN_STOCK_LIST
} from '../actions/stock';

const stock = (state = Map({
  payload: List([]),
  isFetching: false,
  error: false
}), action) => {
  let newState, updatedPayload, index, payload = state.get('payload');
  switch (action.type) {

      // Requests
      case GET_STOCK_LIST_REQUEST:
      case GET_STOCK_REQUEST:
      case CREATE_STOCK_REQUEST:
      case UPDATE_STOCK_REQUEST:
          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      // Success
      case GET_STOCK_LIST_SUCCESS:
      case GET_STOCK_SUCCESS:
      case CLEAN_STOCK_LIST:
          newState = state.merge({
              payload: fromJS(action.payload),
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      case CREATE_STOCK_SUCCESS:
          // Check if payload is a List (Array)
          if(List.isList(payload)) {
              // Find the index of the work-report to be updated inside the List
              index = payload.findIndex(item => {
                  return item.get('_id') === action.payload._id;
              });
              // Update the payload list
              if (index !== -1) {
                  updatedPayload = payload.update(index, () => {
                      return fromJS(action.payload);
                  });
              }
              else {
                  updatedPayload = payload.push(fromJS(action.payload));
              }
              // If payload is a Map the payload to be updated is action.payload itself
          } else if(Map.isMap(payload)) {
              updatedPayload = fromJS(action.payload);
          }

          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error,
              created: action.created,
              payload: updatedPayload
          });
          return newState;

      case UPDATE_STOCK_SUCCESS:

          // Check if payload is a List (Array)
          if(List.isList(payload)) {
              // Find the index of the warehouse to be updated inside the List
              index = payload.findIndex(item => {
                  return item.get('_id') === action.payload._id;
              });
              // Update the payload list
              if (index !== -1) {
                  updatedPayload = payload.update(index, () => {
                      return fromJS(action.payload);
                  });
              }
              // If payload is a Map the payload to be updated is action.payload itself
          } else if(Map.isMap(state.get('payload'))) {
              updatedPayload = fromJS(action.payload);
          }
          newState = state
              .merge({
                  isFetching: action.isFetching,
                  error: action.error,
                  updated: action.updated,
                  payload: updatedPayload
              });
          return newState;

      // Errors
      case GET_STOCK_LIST_ERROR:
      case GET_STOCK_ERROR:
      case CREATE_STOCK_ERROR:
      case UPDATE_STOCK_ERROR:
          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error,
              errorMessage: action.errorMessage
          });
          return newState;
      default:
          return state;
  }
};

export default stock;



// WEBPACK FOOTER //
// ./src/reducers/stock.js